import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '@contexts/auth-context';

interface RouteGuardProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}
function RouteGuard({ children, adminOnly = false }: RouteGuardProps) {
  const authContext = useContext(AuthContext);

  // Handle undefined context gracefully
  if (!authContext) {
    return <Navigate to="/login" />;
  }

  const { isLoading, isAuthenticated, isUserInGroup } = authContext;

  if (isLoading) {
    return null;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && !isUserInGroup('admin')) {
    console.warn('Unauthorized access attempt to admin route');
    return <Navigate to="/unauthorized" />;
  }
  return children;
}

export default RouteGuard;
